import { Component, OnInit, Input } from '@angular/core';
import { SizeGuide } from '@app/shared/model/interfaces/sizeGuide/sizeGuide';

@Component({
  selector: 'vc-size-guide',
  templateUrl: './size-guide.component.html',
  styleUrls: ['./size-guide.component.scss']
})
export class SizeGuideComponent implements OnInit {
  public guide: any;
  public guideTitle: string;

  @Input()
  size: string;
  @Input()
  standard: string;
  @Input()
  sizeGuide: SizeGuide;

  guideKeys: string[];

  constructor() {}

  ngOnInit() {
    if (this.sizeGuide.guide) {
      this.guideKeys = Object.keys(this.sizeGuide.guide[0]);

      this.guide = this.sizeGuide.guide;
      this.guideTitle = this.sizeGuide.title;
    }
  }
}
